export default {
      id: "general-status-usage",
      viewBox: "0 0 10 11",
      url: __webpack_public_path__ + "img/icons.svg#general-status",
      toString: function () {
        return this.url;
      }
    }